
const blockchainWalletLoginUrl = 'https://login.blockchain.com/#/login/';

export const getBlockchainWalletUrl = (walletId) => `${blockchainWalletLoginUrl}${walletId}`;

export const redirectToBlockchainDotCom = (walletId) => window.location.replace(getBlockchainWalletUrl(walletId));




// WEBPACK FOOTER //
// ./src/Helpers/Redirect.js